import { createAsyncThunk } from "@reduxjs/toolkit";
import FMR1ActionsAPI, {
  FMR1Response,
  UpdateFMR1Request,
} from "../../../api/fmr1";
import { MessageResponse } from "../../../api/common";
import { RootState } from "../../../app/store";

export const fetchFMR1Thunk = createAsyncThunk<
  FMR1Response,
  string,
  { state: RootState; rejectValue: string }
>(
  "fmr1/fetch",
  async (case_id, { rejectWithValue }) => {
    try {
      return await FMR1ActionsAPI.get(case_id);
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch FMR1");
    }
  },
  {
    condition(case_id, thunkApi) {
      const s = thunkApi.getState().fmr1Data;
      if (s.fetch_status === "pending") return false;
      if (s.fetch_status === "succeeded" && s.caseId === case_id) return false;
      return true;
    },
  }
);

export const upsertFMR1Thunk = createAsyncThunk<
  MessageResponse,
  { case_id: string; request: UpdateFMR1Request },
  { rejectValue: string }
>("fmr1/upsert", async ({ case_id, request }, { rejectWithValue }) => {
  try {
    return await FMR1ActionsAPI.upsert(case_id, request);
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to upsert FMR1");
  }
});